module.exports = __webpack_public_path__ + "static/media/user (5).00c52bdf.svg";